/* Magic Milk - Infokarten unter den Spar-Sets.

   Mert, 22.08.2026: er hat `aureon-wechselkarten-fuer-shopify.html` geschickt,
   "pass das an den design ohne die schriftart", danach "shopify seite weiter
   bearbeiten". Das ist die Shop-Fassung dieses Bausteins.

   ZWEI KARTEN, sechs Inhalte, versetzt im Wechsel. Sie haengen sich direkt
   unter die Sektion darueber (#mmSets) und liegen im selben dunklen Block.

   SCHRIFT: keine. Der Baustein erbt die des Shops. Die Vorlage hatte
   `font-family: inherit, system-ui, ...` - das ist ungueltiges CSS, eine
   Liste mit `inherit` darin verwirft der Browser komplett.

   FARBEN: Grund #FFFFFF, Karte #1E1519 (dunkel auf hell), Radius 18/22 px,
   Glassymbol 30/38 px,
   Punkte 5 px / aktiv 16 px - dieselben Werte wie mm-zweikarten.

   06.09.2026, Mert: "Und mach verschiedene Farben, zum Beispiel bei Whatsapp,
   Gruen. du hast zu viel mit Pink und Rot gearbeitet. Farblicher."
   Bis dahin trugen alle sechs Karten nur Rot, Pink oder Creme - der Kopf des
   Bausteins hielt Gold, Gruen und Blau ausdruecklich fuer keine Magic-Milk-
   Farben. Mert hebt das hier auf: jede Karte bekommt ihre eigene Farbe, und
   die WhatsApp-Karte bekommt Gruen. Rot und Pink kommen im Symbol gar nicht
   mehr vor.

   Jeder Ton ist mit 30 % Creme (#F3E9EC) gedaempft - Merts Regel vom
   30.08.2026 "Farben nie knallig", Werte gerechnet statt geschaetzt. Bei den
   dort genannten 55-65 % werden auf dunklem Grund alle sechs pastellig und
   verlieren ihre Identitaet; das waere das Gegenteil von "farblicher". 30 %
   nimmt das Grelle heraus und laesst den Farbton stehen.

   Gemessen auf der Karte #1E1519: kleinster Kontrast 6.98 (Grenze fuer
   Grafik 3.0), kleinster Abstand im Farbkreis 32 Grad - keine zwei Karten
   koennen verwechselt werden.

   Farbe traegt weiterhin NUR das Symbol und der aktive Punkt, nie die Flaeche
   und nie Text - feste Regeln "kein rotes KI-Design" und "kein pinker Text".

   KEIN UEBERLAPPEN: alle sechs Blaetter liegen uebereinander, `visibility`
   schaltet OHNE Uebergang um. Damit koennen nie zwei Texte gleichzeitig
   lesbar sein, und die Kartenhoehe steht fest - sie springt beim Wechsel nicht.

   INHALTE am 22.08.2026 gegen den echten Shop geprueft. Drei Aussagen der
   Vorlage waren falsch und stehen hier NICHT:
     - "Kostenlos ab 49 EUR": es gibt keine Freigrenze. Versandprofil
       Deutschland = 5,99 Standard / 19,99 Express / 15,99 Nachnahme.
     - "Bestellungen bis 14 Uhr gehen am selben Tag raus": steht nirgends
       in den Versandbedingungen.
     - "Ungeoeffnet zurueck": kennt das gesetzliche Widerrufsrecht nicht.
   Ebenso raus: "Klarna" und "auf Rechnung" (kommen auf der Seite nicht vor)
   und "Hergestellt in der EU" (nirgends belegt).
   Bestaetigt: 1-3 Werktage nach Deutschland, 14 Tage Widerruf ohne Angabe
   von Gruenden. */
(function () {
  var TAKT    = 7000;   /* wie lange ein Inhalt steht */
  var VERSATZ = 3500;   /* damit nie beide Karten gleichzeitig springen */

  /* Alle Werte = Rohton + 30 % Creme, nachgerechnet (siehe Kopf). */
  var FARBE = {
    bernstein: '#F2AE7B',   /* Versand    - warm, wie Karton */
    blau:      '#72B4F4',   /* Lieferzeit - kuehl, Verlaesslichkeit */
    violett:   '#B591EB',   /* Widerruf   - eigenes Recht, klar abgesetzt */
    hell:      '#F3E9EC',   /* Zahlung    - neutral */
    tuerkis:   '#6AC5BC',   /* Sendung    - Bewegung, Verfolgung */
    gruen:     '#63DA8E'    /* Support    - WhatsApp */
  };

  var SYM = {
    paket: '<path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4"/>',
    uhr:   '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    haken: '<path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>',
    karte: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/>',
    ort:   '<path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
    chat:  '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.9 8.9 0 0 1-4-.9L3 21l1.9-4.5A8.4 8.4 0 0 1 4 11.5 8.4 8.4 0 0 1 12.5 3h.5a8.4 8.4 0 0 1 8 8.5z"/>'
  };

  var INHALT = [
    { sym: 'paket', farbe: 'bernstein',  auge: 'Versand',
      titel: 'Standard 5,99 \u20ac',
      text:  'Express und Nachnahme stehen im Checkout zur Wahl.',
      link:  '/policies/shipping-policy' },

    { sym: 'uhr',   farbe: 'blau', auge: 'Lieferzeit',
      titel: '1 bis 3 Werktage',
      text:  'Innerhalb Deutschlands, nach \u00dcbergabe an den Versand.' },

    { sym: 'haken', farbe: 'violett', auge: 'Widerruf',
      titel: '14 Tage Zeit',
      text:  'Ohne Angabe von Gr\u00fcnden \u2014 \u00fcber unser Widerrufscenter.',
      link:  '/policies/refund-policy' },

    { sym: 'karte', farbe: 'hell', auge: 'Zahlung',
      titel: 'Karte, PayPal, Rechnung',
      text:  'Klarna, Nachnahme und internationale Zahlarten ebenso m\u00f6glich.' },

    { sym: 'ort',   farbe: 'tuerkis',  auge: 'Sendung',
      titel: 'Immer verfolgbar',
      text:  'Die Sendungsnummer kommt automatisch per E-Mail.' },

    { sym: 'chat',  farbe: 'gruen', auge: 'Support',
      titel: 'Direkt per WhatsApp',
      text:  'support@magicmilk.de oder +49 15565 408252.' }
  ];

  var css = [
    /* Der Block schliesst oben buendig an #mmZwei an - deshalb oben kein
       Abstand, sonst entsteht eine dunkle Naht. */
    '#mmInfo{flex:0 0 auto;align-self:stretch;width:100%;box-sizing:border-box;',
    /* 06.09.2026, Mert: "Du sollst den Hintergrund nicht dunkel machen,
       sondern nur die Sections dunkel. [...] genauso Farbe lassen, aber
       Hintergrund weiss." Also: die KARTEN bleiben dunkel (#1E1519) mit
       cremefarbenem Text und den sechs Symbolfarben - nur die Flaeche
       dahinter wird weiss. Vorher war beides dunkel, dazwischen sah man
       die Karten kaum. Die Textfarbe der Sektion dreht mit: sie ist nur
       ein Rueckfall, alle Texte in der Karte setzen ihre Farbe selbst -
       aber creme auf Weiss waere unsichtbar, falls doch etwas erbt. */
    'background:#FFFFFF;color:#151013;padding:0 0 22px;margin:0}',
    '#mmInfo *{box-sizing:border-box}',
    '#mmInfoInnen{max-width:1180px;margin:0 auto;padding:0 16px;',
    'display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    /* Gleiche Hoechstbreite wie die Beutel-Karten darueber, damit beide Bloecke
       am Rechner eine ruhige Spalte bilden (feste Regel vom 22.08.2026:
       "Auf PC niemals so gross", Handy und PC eins zu eins). */
    '@media(min-width:900px){#mmInfoInnen{gap:20px;padding:0 20px;',
    'grid-template-columns:repeat(2,minmax(0,340px));justify-content:center}}',
    '@media(max-width:339px){#mmInfoInnen{grid-template-columns:1fr}}',

    '.mmIKarte{position:relative;overflow:hidden;background:#1E1519;',
    'border:1px solid rgba(243,233,236,.07);border-radius:18px;',
    'padding:12px 14px 14px;display:flex;flex-direction:column;',
    'transition:border-color .25s ease,transform .25s cubic-bezier(.22,1,.36,1)}',
    '@media(min-width:900px){.mmIKarte{border-radius:22px;padding:16px 20px 20px}}',
    '.mmIKarte:hover{border-color:rgba(243,233,236,.18);transform:translateY(-2px)}',

    /* Glasschimmer, neutral hell. Bewusst KEINE farbige Flaeche - feste Regel
       "kein rotes KI-Design": aktive Zustaende als Glas, Rot nur als Akzent. */
    '.mmIKarte::after{content:"";position:absolute;inset:0;pointer-events:none;',
    'background:radial-gradient(80% 60% at 0% 0%,rgba(255,255,255,.05),transparent 60%)}',

    /* Symbol - dieselbe Glasflaeche wie in mm-zweikarten. Alle sechs Zeichen
       liegen uebereinander, nur eines ist sichtbar. */
    '.mmISymbol{position:relative;z-index:1;width:30px;height:30px;',
    'border-radius:9px;display:flex;align-items:center;justify-content:center;',
    'background:rgba(21,16,19,.55);border:1px solid rgba(255,255,255,.22);',
    '-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);',
    'margin-bottom:9px;flex:0 0 auto}',
    '.mmISymbol svg{position:absolute;width:16px;height:16px;',
    'opacity:0;visibility:hidden;transition:opacity .4s ease}',
    '.mmISymbol svg.da{opacity:1;visibility:visible}',
    '@media(min-width:900px){.mmISymbol{width:38px;height:38px;border-radius:12px;',
    'margin-bottom:11px}.mmISymbol svg{width:20px;height:20px}}',

    /* Textfeld mit fester Mindesthoehe - so springt die Karte beim Wechsel nicht. */
    /* Die Blaetter stapeln sich in EINER Rasterzelle - so rechnet der Browser
       die Feldhoehe selbst aus dem laengsten Text. Feste Pixelwerte waren in
       mm-zweikarten genau die Ursache dafuer, dass Text unter die Punkte lief
       (22.08.2026 gemessen: 74 px Feld, 98 px Text). Die Mindesthoehe ist nur
       noch ein Boden, keine Deckelung. */
    '.mmIFeld{position:relative;z-index:1;flex:1 1 auto;display:grid;',
    'align-items:start;min-height:96px}',
    '@media(min-width:900px){.mmIFeld{min-height:108px}}',
    '.mmIBlatt{grid-area:1/1;opacity:0;visibility:hidden;',
    'transform:translateY(7px);pointer-events:none;',
    'transition:opacity .45s ease,transform .45s ease}',
    '.mmIBlatt.da{opacity:1;visibility:visible;transform:none;pointer-events:auto}',
    '@media(prefers-reduced-motion:reduce){.mmIBlatt{transition:none;transform:none}}',

    /* Augenbraue klein und gedaempft, nie pink (feste Regel). */
    '.mmIAuge{font-size:.6rem;font-weight:700;letter-spacing:.16em;',
    'text-transform:uppercase;color:rgba(243,233,236,.42);margin:0 0 5px}',
    '@media(min-width:900px){.mmIAuge{font-size:.68rem}}',
    /* Sprung zur Ueberschrift liegt ueber Faktor 2 (Grundregel 2). */
    '.mmITitel{font-size:.98rem;line-height:1.2;font-weight:800;margin:0 0 5px;',
    'color:#F3E9EC;letter-spacing:-.01em}',
    '@media(min-width:900px){.mmITitel{font-size:1.35rem}}',
    '.mmIText{font-size:.78rem;line-height:1.45;margin:0;',
    'color:rgba(243,233,236,.55)}',
    '@media(min-width:900px){.mmIText{font-size:.95rem}}',

    '.mmIPunkte{position:relative;z-index:1;display:flex;gap:5px;',
    'align-items:center;margin-top:auto;padding-top:10px}',
    '.mmIPunkt{width:5px;height:5px;border-radius:999px;',
    'background:rgba(243,233,236,.20);transition:width .35s ease,background .35s ease}',
    '.mmIPunkt.da{width:16px;background:var(--f,#F3E9EC)}'
  ].join('');

  var karten = [];      /* je Karte: blaetter, punkte, symbole, stand, uhr */
  var ruhig  = false;
  var rafId  = 0;

  try { ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function jetztMs() {
    return (window.performance && performance.now) ? performance.now() : +new Date();
  }

  function zeigen(k, i) {
    var n = INHALT.length;
    var wahl = ((i % n) + n) % n;
    k.stand = wahl;
    k.blaetter.forEach(function (b, j) { b.classList.toggle('da', j === wahl); });
    k.punkte.forEach(function (p, j)   { p.classList.toggle('da', j === wahl); });
    k.symbole.forEach(function (v, j)  { v.classList.toggle('da', j === wahl); });
    var ziel = INHALT[wahl].link;
    k.wirt.onclick = ziel ? function () { window.location.href = ziel; } : null;
    k.wirt.style.cursor = ziel ? 'pointer' : '';
    k.uhr = jetztMs();
  }

  /* Eine Zeitmessung je Karte, aber EIN Taktgeber - so koennen die beiden
     nicht auseinanderlaufen und behalten trotzdem ihren Versatz. */
  function pruefen() {
    var t = jetztMs();
    karten.forEach(function (k, nr) {
      if (t - k.uhr < TAKT) return;
      var andere = karten[1 - nr];
      var neu = k.stand + 2;
      /* Nie zweimal dasselbe nebeneinander. */
      if (andere && ((neu % INHALT.length) === andere.stand)) neu += 1;
      zeigen(k, neu);
    });
  }
  function rahmen() { pruefen(); rafId = window.requestAnimationFrame(rahmen); }

  function bauen() {
    if (document.getElementById('mmInfo')) return true;
    /* 22.08.2026: Die Sektion darueber ist an einem Tag zweimal gewechselt
       (#mmZwei -> #mmSorten -> #mmSets). Jedes Mal waeren die Infokarten
       stillschweigend verschwunden, weil ihr Anker weg war. Darum jetzt eine
       Reihe von Ankern: der erste, den es gibt, gewinnt. */
    var anker = null;
    ['mmBeutel', 'mmSets', 'mmSorten', 'mmZwei', 'mmHigh'].some(function (id) {
      anker = document.getElementById(id);
      return !!anker;
    });
    if (!anker || !anker.parentNode) return false;

    var st = document.createElement('style');
    st.id = 'mmInfo-stil';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    function karteHtml() {
      return '<article class="mmIKarte">' +
               '<span class="mmISymbol">' +
                 INHALT.map(function (p) {
                   return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                          'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
                          'aria-hidden="true" style="color:' + (FARBE[p.farbe] || FARBE.hell) + '">' +
                          SYM[p.sym] + '</svg>';
                 }).join('') +
               '</span>' +
               '<div class="mmIFeld">' +
                 INHALT.map(function (p) {
                   return '<div class="mmIBlatt">' +
                            '<p class="mmIAuge">'  + p.auge  + '</p>' +
                            '<p class="mmITitel">' + p.titel + '</p>' +
                            '<p class="mmIText">'  + p.text  + '</p>' +
                          '</div>';
                 }).join('') +
               '</div>' +
               '<div class="mmIPunkte">' +
                 INHALT.map(function (p) {
                  return '<i class="mmIPunkt" style="--f:' +
                         (FARBE[p.farbe] || FARBE.hell) + '"></i>';
                }).join('') +
               '</div>' +
             '</article>';
    }

    var s = document.createElement('section');
    s.id = 'mmInfo';
    s.setAttribute('aria-label', 'Gut zu wissen');
    s.innerHTML = '<div id="mmInfoInnen">' + karteHtml() + karteHtml() + '</div>';

    /* direkt UNTER die Spar-Set-Karten */
    anker.parentNode.insertBefore(s, anker.nextSibling);

    karten = [].map.call(s.querySelectorAll('.mmIKarte'), function (w) {
      return {
        wirt:     w,
        blaetter: [].slice.call(w.querySelectorAll('.mmIBlatt')),
        punkte:   [].slice.call(w.querySelectorAll('.mmIPunkt')),
        symbole:  [].slice.call(w.querySelectorAll('.mmISymbol svg')),
        stand:    0,
        uhr:      0
      };
    });

    zeigen(karten[0], 0);
    zeigen(karten[1], 1);
    /* Die rechte Karte startet mit halbem Vorlauf, damit die beiden nie
       gleichzeitig umspringen. */
    karten[1].uhr = jetztMs() - (TAKT - VERSATZ);

    if (!ruhig) {
      rafId = window.requestAnimationFrame(rahmen);
      /* Absicherung, wenn rAF steht (verstecktes Fenster, Vorschau). */
      setInterval(pruefen, 250);
    }
    return true;
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (bauen() || n > 25) clearInterval(t);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else {
    versuchen();
  }
  window.addEventListener('load', versuchen);
})();
